module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAACXBIWXMAABcSAAAXOQER7y87AAAAB3RJTUUH3AsbChsyNZaItwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABFSURBVEjHY0xLS2PABoyNjbGKnz17liT1TAw0BqMWjFpAOWChVnrHpX40DkYtGAr5gFrpfbQ+GLVgtD4YrQ9GLRjSFgAAbfUXEVeGAdQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/textures/transtexture.png
// module id = 1628
// module chunks = 28